// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oR3U","fullView":"styles_fullView__1e-kI"};